import { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Home2 from '../pages/Home2';
import ProtectedRoute from '../components/ProtectedRoute';
import { routes } from './routes';

/** 懒加载期间的过渡占位（避免白屏闪烁） */
function RouteFallback() {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '50vh',
            gap: '12px',
            color: '#888',
            fontSize: '14px',
        }}>
            <div style={{
                width: 32,
                height: 32,
                border: '3px solid rgba(0, 0, 0, 0.08)',
                borderTopColor: '#1890ff',
                borderRadius: '50%',
                animation: 'router-spin 0.8s linear infinite',
            }} />
            <span>页面加载中...</span>
            <style>{'@keyframes router-spin { to { transform: rotate(360deg); } }'}</style>
        </div>
    );
}

/**
 * 路由入口（配置驱动）
 * - 所有工具页面均懒加载，首屏只加载 Home 与路由本身
 * - protected 路由由 <ProtectedRoute /> 统一包裹
 * - 404 兜底固定在最后，保证通配路由不会吞掉后面的匹配
 */
export default function AppRouter() {
    const publicRoutes = routes.filter((r) => !r.protected);
    const protectedRoutes = routes.filter((r) => r.protected);

    return (
        <Suspense fallback={<RouteFallback />}>
            <Routes>
                {/* 首页（同步加载，保证首屏速度） */}
                {/*<Route path="/home/:cateCode?" element={<Home />} />*/}
                <Route path="/" element={<Home2 />} />

                {/* 根路径重定向 
                <Route path="/" element={<Navigate to="/home" replace />} />
                */}
                {/*<Route path="/" element={<Navigate to="/home" replace />} />*/}
                


                {/* 公共路由 */}
                {publicRoutes.map(({ path, component: Component }) => (
                    <Route key={path} path={path} element={<Component />} />
                ))}

                {/* 需要登录的路由 */}
                {protectedRoutes.length > 0 && (
                    <Route element={<ProtectedRoute />}>
                        {protectedRoutes.map(({ path, component: Component }) => (
                            <Route key={path} path={path} element={<Component />} />
                        ))}
                    </Route>
                )}

                {/* 404 兜底（必须放在最后） */}
                <Route path="*" element={<h3>页面不存在404</h3>} />
            </Routes>
        </Suspense>
    );
}
